// extracted by mini-css-extract-plugin
export default {"link":"LemlistCard_link__C6E7n","logo":"LemlistCard_logo__rkNHs","body":"LemlistCard_body__H8+j9","text":"LemlistCard_text__Zfu2F","actions":"LemlistCard_actions__mrGLO"};